// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_JWP","cls2":"ClaimDetails-cls2_j4S ClaimDetails-cls1_JWP"};